import {
    LEAD_MANAGER_CHANGE_LEADS_STATUS_REQUEST,
    LEAD_MANAGER_CHANGE_LEADS_STATUS_FAILURE,
    LEAD_MANAGER_CHANGE_LEADS_STATUS_SUCCESS,
} from '../constants/lead_manage_leads_status.constants';

export const leadManagerChangeLeadsStatusRequest = (id, shouldKill, margin) => ({
    type: LEAD_MANAGER_CHANGE_LEADS_STATUS_REQUEST,
    id,
    shouldKill,
    margin,
});
export const leadManagerChangeLeadsStatusRequestSuccess = payload => ({
    type: LEAD_MANAGER_CHANGE_LEADS_STATUS_SUCCESS,
    payload,
});
export const leadManagerChangeLeadsStatusRequestFailure = error => ({
    type: LEAD_MANAGER_CHANGE_LEADS_STATUS_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/redux/actions/lead_manager_lead_status.actions.js